import { OverlayControlButton } from '@/components/OverlayControlButton'
import CameraIcon from '@/CustomIcons/CameraIcon'
import HeadphonesIcon from '@/CustomIcons/HeadphonesIcon'
import MicrophoneIcon from '@/CustomIcons/MicrophoneIcon'
import MicrophoneOffIcon from '@/CustomIcons/MicrophoneOffIcon'
import CameraOffIcon from '@/CustomIcons/CameraOffIcon'
import { MusePeer } from '@/services/RoomContextMusePeer'
import useRoomActions from '@/services/useRoomActions'
import { cn } from '@/utlis/cn'
import { carmackClick } from '@/utils'

type CameraControlsOverlayProps = {
    peer: MusePeer | 'me'
    sidebar?: boolean
    className?: string
}
export function CameraControlsOverlay(props: CameraControlsOverlayProps) {
    const {
        calcIsMyAudioDeviceAllMuted,
        toggleMyAudioDeviceMute,
        isMyVideoDeviceMuted,
        toggleMyVideoDeviceMute,
        toggleRemoteAudioMute,
        toggleRemoteVideoMute,
        calcIsRemoteAudioDeviceAllMuted,
        calcAllRemoteAudioDevicesAreMutedByOwner,
        calcRemoteVideoDeviceIsMutedByOwner,
        toggleRemoteAudioSolo,
        calcIsRemoteAudioDeviceAllSoloed,
    } = useRoomActions()

    let mutedAudio = false
    let mutedVideo = false
    let soloed = false
    let audioRemoteMuted = false
    let videoRemoteMuted = false

    if (props.peer === 'me') {
        mutedAudio = calcIsMyAudioDeviceAllMuted()
        mutedVideo = isMyVideoDeviceMuted()
        soloed = false
    } else {
        audioRemoteMuted = calcAllRemoteAudioDevicesAreMutedByOwner(props.peer.remoteAudios, props.peer.manifest)
        mutedAudio = calcIsRemoteAudioDeviceAllMuted(props.peer) || audioRemoteMuted

        const isVideoHidden = props.peer.remoteVideoControlStates?.isMuted || false
        videoRemoteMuted = calcRemoteVideoDeviceIsMutedByOwner(props.peer.manifest)
        mutedVideo = isVideoHidden || videoRemoteMuted

        soloed = calcIsRemoteAudioDeviceAllSoloed(props.peer)
    }

    const handleMuteAudio = () => {
        if (props.peer === 'me') {
            toggleMyAudioDeviceMute()
        } else {
            if (!audioRemoteMuted) {
                toggleRemoteAudioMute(props.peer)
            }
        }
    }

    const handleMuteVideo = () => {
        if (props.peer === 'me') {
            toggleMyVideoDeviceMute()
        } else {
            if (!videoRemoteMuted) {
                toggleRemoteVideoMute(props.peer)
            }
        }
    }

    const handleSolo = () => {
        if (props.peer !== 'me') {
            toggleRemoteAudioSolo(props.peer)
        }
    }

    const position = props.sidebar ? 'bottom-1 left-1' : 'bottom-[16px] left-[16px]'
    const fontSize = '1.3rem'

    return (
        <div className={cn('video-overlay-controls absolute flex gap-1 items-center justify-start z-10', position)}>
            <OverlayControlButton
                onMouseDown={carmackClick(() => handleMuteAudio())}
                className={cn(mutedAudio ? 'opacity-100' : 'opacity-0', mutedAudio && 'text-muse-danger')}
            >
                {mutedAudio ? <MicrophoneOffIcon style={{ fontSize }} /> : <MicrophoneIcon style={{ fontSize }} />}
            </OverlayControlButton>

            <OverlayControlButton
                onMouseDown={carmackClick(handleMuteVideo)}
                className={cn(mutedVideo ? 'opacity-100' : 'opacity-0')}
            >
                {mutedVideo ? (
                    <CameraOffIcon className="text-muse-danger" style={{ fontSize }} />
                ) : (
                    <CameraIcon style={{ fontSize }} />
                )}
            </OverlayControlButton>
            {props.peer !== 'me' && (
                <OverlayControlButton
                    onMouseDown={carmackClick(handleSolo)}
                    className={cn(
                        'relative',
                        soloed
                            ? 'opacity-100 text-black bg-[radial-gradient(526.28%_147.67%_at_0.42%_9.62%,#FCE640_0%,#F49629_77.07%,#F17E22_100%)] hover:bg-[radial-gradient(ellipse_160%_150%_at_0.42%_9.62%,#FCE640_0%,#F49629_40%,#F17E22_100%)]'
                            : 'opacity-0 text-muse-fg'
                    )}
                >
                    <HeadphonesIcon className="-mt-1 mb-1" style={{ fontSize }} />
                    <span className="absolute bottom-[3px] left-0 right-0 text-[9px] font-light">Solo</span>
                </OverlayControlButton>
            )}
        </div>
    )
}
